import React, {useEffect, useState} from 'react';
import {Box, Typography, Card} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { alpha, useTheme } from '@mui/material/styles';
import imgSlider1 from '../../../assets/Images/trip_planner.jpg';

import Container from '../../Container';
import SearchToursForm from './SearchToursForm';
import {useAppSelector} from "../../../hooks/hooks";

type SearchToursContainerProps = {
    plannedToursLimitReached?: boolean;
    plannedToursCount?: number;
    maxPlannedTours?: number | null;
};

const SearchToursContainer = ({ plannedToursLimitReached = false, plannedToursCount = 0, maxPlannedTours = null }: SearchToursContainerProps): JSX.Element => {
  const theme = useTheme();
  const mode = theme.palette.mode;
    const [rightImage, setRightImage] = useState(imgSlider1.toString())

  const regions = useAppSelector(state => state.region.regions);
  const regionIdFromState = useAppSelector(state => state.vanliferComponents.searchFormData?.regionId);

    useEffect(() => {
        if (regions && regionIdFromState) {
            const region = regions.find(region => region.regionId === regionIdFromState);
            if (region && region.imageIds && region.imageIds.length > 0) {
                setRightImage(`${process.env.REACT_APP_API_URL as string}/image/${region.imageIds[0]}`);
            } else {
                setRightImage(imgSlider1.toString());
            }
        }
    }, [regionIdFromState, regions]);


    const LeftSide = () => {
        const theme = useTheme();
        const isMd = useMediaQuery(theme.breakpoints.up('md'));
        return (
            <Card
                elevation={3}
                sx={{
                    p: {xs: 3, md: 4},
                    borderRadius: 3,
                    backgroundColor: theme.palette.background.paper,
                    boxShadow: theme.shadows[4],
                }}
            >
                <Box data-aos={isMd ? 'fade-right' : 'fade-up'}>


                    <Box mb={3}>
                        <Typography variant="h6" color="text.secondary">
                            Gib dein Wunschdatum ein und wähle eine Region, die du entdecken möchtest.
                        </Typography>
                    </Box>

                    <Box
                        display="flex"
                        flexDirection={{xs: 'column', sm: 'row'}}
                        alignItems={{xs: 'stretch', sm: 'flex-start'}}
                        gap={2}
                    >
                        <SearchToursForm
                            plannedToursLimitReached={plannedToursLimitReached}
                            plannedToursCount={plannedToursCount}
                            maxPlannedTours={maxPlannedTours}
                        />
                    </Box>
                </Box>
            </Card>
        );
    };

    return (
        <React.Fragment>
        <Typography
            sx={{
                textTransform: 'uppercase',
                fontWeight: 500,
                letterSpacing: 1,
            }}
            gutterBottom
            color="text.secondary"
        >
            Reiseplaner
        </Typography>

    <Box mb={2}>
        <Typography
            variant="h3"
            component="h2"
            color="text.primary"
            fontWeight={700}
            lineHeight={1.2}
        >
            Generier dir {' '}
            <Typography
                component="span"
                variant="inherit"
                color="text.primary"
                sx={{
                    background: `linear-gradient(180deg, transparent 82%, ${alpha(
                        mode === 'light'
                            ? theme.palette.secondary.main
                            : theme.palette.primary.main,
                        0.3
                    )} 0%)`,
                }}
            >
                Eigene Reisevorschläge
            </Typography>
        </Typography>
        <Box mb={3}>
            <Typography variant="h6" color="text.secondary">
                Lass dir Reisevorschläge machen – individuell und speziell für dich.
                Gib dein Wunschdatum ein und wähle eine Region, die du entdecken möchtest.
            </Typography>
        </Box>
    </Box>
        <Box
            sx={{
                width: 1,
                minHeight: { xs: 500, md: '50vh' },
                borderRadius: 4,
                overflow: 'hidden',
                backgroundImage: `url(${rightImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                px: { xs: 2, md: 8 },
                py: { xs: 4, md: 6 },
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    inset: 0,
                    backgroundColor: 'rgba(0,0,0,0.3)', // optionaler Overlay
                    zIndex: 1,
                },
            }}
        >
            <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 2 }}>
                <Box sx={{ maxWidth: 400 }}>
                    <LeftSide />
                </Box>
            </Container>
        </Box>
        </React.Fragment>
    );
};

export default SearchToursContainer;
